/**
 * Maps the grading panel's internal settings object (the DEFAULT_GRADING shape: flat scalar
 * keys plus `curveRGB`/`curveR`/`curveG`/`curveB` as null-or-`[[x, y], ...]` arrays) to and
 * from the typed `protos.vision.grading.v1.GradingSettings` message. protobuf-es unwraps the
 * `Int32Value` scalars to `number | undefined`; curves are `{ x, y }[]`, empty = identity.
 *
 * `fromProto` omits absent scalars (so the caller's `{ ...DEFAULT_GRADING, ...settings }` merge
 * supplies the neutral value — saturation's neutral is 100, not 0) and returns `null`, never
 * `[]`, for an empty curve (the tone-curve UI's null checks depend on it).
 */

const SCALAR_KEYS = [
  'temperature', 'tint', 'exposure', 'contrast', 'highlights', 'shadows',
  'blacks', 'fade', 'vibrance', 'saturation', 'grain', 'halation', 'vignette',
];

const CURVE_KEYS = {
  curveRGB: 'curveRgb',
  curveR: 'curveR',
  curveG: 'curveG',
  curveB: 'curveB',
};

function pointsToProto(curve) {
  return Array.isArray(curve) ? curve.map(([x, y]) => ({ x, y })) : [];
}

function pointsFromProto(points) {
  return points && points.length ? points.map((point) => [point.x, point.y]) : null;
}

export function toProtoGradingSettings(settings) {
  const out = {};
  for (const key of SCALAR_KEYS) {
    if (settings[key] !== undefined && settings[key] !== null) out[key] = settings[key];
  }
  for (const [internalKey, protoKey] of Object.entries(CURVE_KEYS)) {
    out[protoKey] = pointsToProto(settings[internalKey]);
  }
  return out;
}

export function fromProtoGradingSettings(settings) {
  if (!settings) return null;
  const out = {};
  for (const key of SCALAR_KEYS) {
    if (settings[key] !== undefined && settings[key] !== null) out[key] = settings[key];
  }
  for (const [internalKey, protoKey] of Object.entries(CURVE_KEYS)) {
    out[internalKey] = pointsFromProto(settings[protoKey]);
  }
  return out;
}
